var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1VolumeMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v4H57v10h-4V40H43v-4h10V26h4v10h10zm-48.21-5L37 15.58V60L18.07 46H14a4 4 0 01-4-4v-7a4 4 0 014-4h4.79zM22 44l11 8.13V24.25l-11 9.3V44z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Volume_more.6574d70f.svg";
export { SvgH1VolumeMore as ReactComponent };